// A BLOG COLLECTION: a hand-picked, hand-ordered set of a site's posts —
// "start here", "the series on X" — that a page shows through a
// `blog-post-collection` element.
//
// Gen-2 (archive/recovered/stack-pkg/src/data/blog-post-collection) stored the
// membership TWICE: `keys`, the ordered slugs, and `posts`, a copy of each
// member's title, abstract and image rebuilt one GetItem at a time whenever the
// collection was saved. The copy went stale the moment a member was
// republished and the rebuild was an N+1 inside a mutation. Here the collection
// stores `postIds` and nothing else about its members; the renderer reads the
// published rows when it composes the page, in parallel, and a post that is
// not published is simply not shown.
//
// By `postId`, not slug, for the same reason the published copy is keyed by it:
// a rename must not silently drop a post out of every collection it is in.
import { properties } from "@repoflow/common/schema-fields";
import { siteKey } from "@common/schema/site/key";

const { createdAt, updatedAt } = properties;

export { createdAt, updatedAt };

export { siteKey };

export const orgId = {
  type: "string",
};

export const siteId = {
  type: "string",
};

// Chosen by the author, the way a section's name is, because an element names
// it and `start-here` is a better thing to see in a config than a uuid.
export const collectionId = {
  label: "Name",
  $ref: "/Name/Required",
  minLength: 1,
  default: "",
};

export const title = {
  label: "Title",
  type: "string",
  maxLength: 256,
  default: "",
};

export const description = {
  label: "Description",
  type: "string",
  textarea: true,
  default: "",
};

export const image = {
  label: "Image",
  $ref: "/Types/Image",
  default: { url: "", description: "" },
};

// Ordered. The order here is the order on the page.
export const postIds = {
  label: "Posts",
  type: "array",
  items: { type: "string" },
  maxItems: 200,
  default: [],
};
